import { render, staticRenderFns } from "./FlexContainer.vue?vue&type=template&id=2890716c&scoped=true&"
import script from "./FlexContainer.vue?vue&type=script&lang=js&"
export * from "./FlexContainer.vue?vue&type=script&lang=js&"
import style0 from "./FlexContainer.vue?vue&type=style&index=0&id=2890716c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2890716c",
  null
  
)

export default component.exports